<template>
  <div>家庭作业</div>
</template>

<script>
export default {

}
</script>

<style>

</style>